(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["homepage-review-showcase"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktopPointer = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const clampReviewMotion = (value, minimum, maximum) => Math.max(minimum, Math.min(maximum, value));

    const activateReviewButtonMotion = (root) => {
      root.querySelectorAll('[data-review-drift-button]').forEach((button) => {
        if (button.dataset.reviewButtonMotionReady === 'true') return;
        button.dataset.reviewButtonMotionReady = 'true';

        let currentX = 0;
        let currentY = 0;
        let targetX = 0;
        let targetY = 0;
        let frame = 0;

        const animate = () => {
          frame = 0;
          currentX += (targetX - currentX) * .16;
          currentY += (targetY - currentY) * .16;
          button.style.setProperty('--review-button-x', `${currentX.toFixed(2)}px`);
          button.style.setProperty('--review-button-y', `${currentY.toFixed(2)}px`);
          if (Math.abs(targetX - currentX) > .06 || Math.abs(targetY - currentY) > .06) {
            frame = window.requestAnimationFrame(animate);
          }
        };

        const queue = () => {
          if (!frame) frame = window.requestAnimationFrame(animate);
        };

        const reset = () => {
          targetX = 0;
          targetY = 0;
          queue();
        };

        const follow = (event) => {
          if (!desktopPointer.matches || reducedMotion.matches) return;
          const bounds = button.getBoundingClientRect();
          const centerX = bounds.left + bounds.width / 2 - currentX;
          const centerY = bounds.top + bounds.height / 2 - currentY;
          const deltaX = event.clientX - centerX;
          const deltaY = event.clientY - centerY;
          const distance = Math.hypot(deltaX, deltaY);
          const influence = Math.max(0, 1 - distance / 520);
          targetX = clampReviewMotion(deltaX * .09 * influence, -26, 26);
          targetY = clampReviewMotion(deltaY * .08 * influence, -18, 18);
          queue();
        };

        document.addEventListener('pointermove', follow, { passive: true });
        document.documentElement.addEventListener('mouseleave', reset);
        window.addEventListener('blur', reset);
      });
    };

    const activateReviewCarousel = (root) => {
      root.querySelectorAll('[data-home-review-showcase]').forEach((showcase) => {
        if (showcase.dataset.reviewCarouselReady === 'true') return;
        showcase.dataset.reviewCarouselReady = 'true';
        const viewport = showcase.querySelector('.home-reviews__viewport');
        const firstGroup = viewport?.querySelector('.home-reviews__group');
        if (!viewport || !firstGroup) return;
        let pausedUntil = 0;
        let hovering = false;
        let focused = false;
        let dragging = false;
        let moved = false;
        let pointerId = null;
        let dragStartX = 0;
        let dragStartScroll = 0;
        let previousTime = performance.now();

        const pauseFor = (duration = 4200) => { pausedUntil = performance.now() + duration; };
        const normalize = () => {
          const loopWidth = firstGroup.offsetWidth;
          if (loopWidth > 0 && viewport.scrollLeft >= loopWidth) viewport.scrollLeft -= loopWidth;
        };

        viewport.addEventListener('mouseenter', () => { hovering = true; });
        viewport.addEventListener('mouseleave', () => { hovering = false; pauseFor(900); });
        viewport.addEventListener('focusin', () => { focused = true; });
        viewport.addEventListener('focusout', () => { focused = viewport.contains(document.activeElement); pauseFor(900); });
        viewport.addEventListener('touchstart', () => pauseFor(4600), { passive: true });
        viewport.addEventListener('touchend', () => pauseFor(3600), { passive: true });
        viewport.addEventListener('scroll', normalize, { passive: true });

        viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          dragging = true;
          moved = false;
          pointerId = event.pointerId;
          dragStartX = event.clientX;
          dragStartScroll = viewport.scrollLeft;
          viewport.classList.add('is-dragging');
          viewport.setPointerCapture(event.pointerId);
          pauseFor(5200);
        });
        viewport.addEventListener('pointermove', (event) => {
          if (!dragging || event.pointerId !== pointerId) return;
          const distance = event.clientX - dragStartX;
          if (Math.abs(distance) > 5) moved = true;
          viewport.scrollLeft = dragStartScroll - distance;
          event.preventDefault();
        });
        const release = (event) => {
          if (!dragging || event.pointerId !== pointerId) return;
          dragging = false;
          pointerId = null;
          viewport.classList.remove('is-dragging');
          pauseFor(4200);
        };
        viewport.addEventListener('pointerup', release);
        viewport.addEventListener('pointercancel', release);
        viewport.addEventListener('click', (event) => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }, true);

        const drift = (time) => {
          const elapsed = Math.min(50, time - previousTime);
          previousTime = time;
          const rewardsOpen = document.documentElement.classList.contains('cart-rewards-overlay-open');
          if (!reducedMotion.matches && !document.hidden && !rewardsOpen && !hovering && !focused && !dragging && time >= pausedUntil) {
            viewport.scrollLeft += elapsed * .022;
            normalize();
          }
          window.requestAnimationFrame(drift);
        };
        window.requestAnimationFrame(drift);
      });
    };

    activateReviewButtonMotion(document);
    activateReviewCarousel(document);
    document.addEventListener('shopify:section:load', (event) => {
      activateReviewButtonMotion(event.target);
      activateReviewCarousel(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
